/*
 *
 * ConfirmProfile actions
 *
 */

import {
  FLUSH_STATE_CONFIRMPROFILE,
  LOAD_CONFIRMPROFILE,
  LOAD_CONFIRMPROFILE_SUCCESS,
  LOAD_CONFIRMPROFILE_ERROR,
  CHANGE_CONFIRMPROFILE,
  CHANGE_CONFIRMPROFILE_SUCCESS,
  CHANGE_CONFIRMPROFILE_ERROR,
  DELETE_CONFIRMPROFILE,
  DELETE_CONFIRMPROFILE_SUCCESS,
  DELETE_CONFIRMPROFILE_ERROR,
} from './constants';

/**
 * Clearing the state for ConfirmProfile
 */
export function flushStateConfirmProfile() {
  return {
    type: FLUSH_STATE_CONFIRMPROFILE,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the ConfirmProfile, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_CONFIRMPROFILE
 */
export function loadConfirmProfile() {
  return {
    type: LOAD_CONFIRMPROFILE,
  };
}

/**
 * Dispatched when the loadConfirmProfile are loaded by the request saga
 *
 * @param  {array} variables true for ConfirmProfile
 *
 * @return {array} An action object with a type of LOAD_CONFIRMPROFILE_SUCCESS passing the variables
 */
export function loadConfirmProfileSuccess(confirmProfileList) {
  return {
    type: LOAD_CONFIRMPROFILE_SUCCESS,
    confirmProfileList,
  };
}

/**
 * Dispatched when loading the loadConfirmProfile fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_CONFIRMPROFILE_ERROR passing the error
 */
export function loadConfirmProfileError(error) {
  return {
    type: LOAD_CONFIRMPROFILE_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the ConfirmProfile, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_CONFIRMPROFILE
 */
export function changeConfirmProfile(confirmProfileData) {
  return {
    type: CHANGE_CONFIRMPROFILE,
    confirmProfileData,
  };
}

/**
 * Dispatched when the changeConfirmProfile are changed/updated by the request saga
 *
 * @param  {array} variables true for ConfirmProfile
 *
 * @return {array} An action object with a type of CHANGE_CONFIRMPROFILE_SUCCESS passing the variables
 */
export function changeConfirmProfileSuccess(confirmProfileData) {
  return {
    type: CHANGE_CONFIRMPROFILE_SUCCESS,
    confirmProfileData,
  };
}

/**
 * Dispatched when loading the changeConfirmProfile fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_CONFIRMPROFILE_ERROR passing the error
 */
export function changeConfirmProfileError(error) {
  return {
    type: CHANGE_CONFIRMPROFILE_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the ConfirmProfile, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_CONFIRMPROFILE
 */
export function deleteConfirmProfile(id) {
  return {
    type: DELETE_CONFIRMPROFILE,
    id,
  };
}

/**
 * Dispatched when the deleteConfirmProfile are deleted by the request saga
 *
 * @param  {object} variables true for ConfirmProfile
 *
 * @return {object} An action object with a type of DELETE_CONFIRMPROFILE_SUCCESS passing the variables
 */
export function deleteConfirmProfileSuccess() {
  return {
    type: DELETE_CONFIRMPROFILE_SUCCESS,
  };
}

/**
 * Dispatched when loading the deleteConfirmProfile fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_CONFIRMPROFILE_ERROR passing the error
 */
export function deleteConfirmProfileError(error) {
  return {
    type: DELETE_CONFIRMPROFILE_ERROR,
    error,
  };
}
